export default __webpack_public_path__ + "static/media/Kaam_25_-_DIVINE___Sacred_Games.005cef17.mp3";